import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import GetContent from '../../Services/Queries/GetContent'
import Content from '../content'
import { Auth } from 'aws-amplify'

export default class DuplicateContent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			contentDetails: {},
			isNewLang: false,
			contentID: '',
			languageModalVisible: false,
			contentLanguageOptions: [
				{
					label: 'English',
					value: 'En',
					id: 0,
				},
				{
					label: 'Telugu',
					value: 'Te',
					id: 1,
				},
			],
			contentSelectedLangVal: null,
			editContent: false,
		}
	}

	editContent = () => {
		this.setState({ editContent: true, languageModalVisible: false })
	}
	componentDidMount = () => {
		const urlParams = window.location.href.split('?')
		if (urlParams && urlParams[1]) {
			this.setState({ contentID: 'cont#' + urlParams[1] }, async () => {
				const input = {
					appInfoFrontEnd: {
						UUID: Auth.user.username,
						appVersionNumber: 62,
					},
					contentID: this.state.contentID,
				}
				const data = await GetContent(input)
				if (data.contentLanguages && data.contentLanguages.length == 1) {
					this.setState({
						contentSelectedLangVal: urlParams[2],
						contentDetails: data,
						editContent: true,
					})
				}
			})
		}
	}
	render() {
		return (
			<div class=' row col-md-12'>

				{this.state.contentSelectedLangVal && this.state.editContent ? (
					<Content
						isNewLang={this.state.isNewLang}
						editContent={true}
						duplicateContent={true}
						contentSelectedLangVal={this.state.contentSelectedLangVal}
						contentDetails={this.state.contentDetails}
					/>
				) : null}
			</div>
		)
	}
}
